import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Grid, Card, CardActionArea, CardContent, Typography } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import FeedbackIcon from '@mui/icons-material/Feedback';
import BugReportIcon from '@mui/icons-material/BugReport';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SettingsIcon from '@mui/icons-material/Settings';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import Header from '../Header';
import AdminNav from './AdminNav';

const CARDS = [
    { path: '/admin/usuarios', label: 'Usuarios', desc: 'Buscar, bloquear y promocionar cuentas', icon: PeopleIcon },
    { path: '/admin/partidas', label: 'Partidas', desc: 'Salas en curso, en espera, canceladas e históricas', icon: SportsEsportsIcon },
    { path: '/admin/sugerencias', label: 'Sugerencias', desc: 'Reportes enviados desde la app', icon: FeedbackIcon },
    { path: '/admin/errores', label: 'Errores', desc: 'Errores de servidor registrados', icon: BugReportIcon },
    { path: '/admin/rankings', label: 'Rankings', desc: 'Recalcular los rankings manualmente', icon: EmojiEventsIcon },
    { path: '/admin/estadisticas', label: 'Estadísticas de uso', desc: 'Jugadores en línea por hora, horas de mayor conectividad', icon: QueryStatsIcon },
    { path: '/admin/configuracion', label: 'Configuración general', desc: 'Versión mínima y forzado de actualización', icon: SettingsIcon },
];

export default function AdminHomeScreen() {
    const navigate = useNavigate();

    return (
        <>
            <Header title="Panel de administración" onBack={() => navigate('/online')} showSettings={false} />
            <AdminNav />
            <Container maxWidth="md" sx={{ mt: 3, mb: 4 }}>
                <Grid container spacing={2}>
                    {CARDS.map(({ path, label, desc, icon: Icon }) => (
                        <Grid item xs={12} sm={6} key={path}>
                            <Card elevation={2}>
                                <CardActionArea onClick={() => navigate(path)} sx={{ p: 2, height: '100%' }}>
                                    <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <Icon color="primary" sx={{ fontSize: '2rem' }} />
                                        <div>
                                            <Typography variant="h6">{label}</Typography>
                                            <Typography variant="body2" color="text.secondary">{desc}</Typography>
                                        </div>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </>
    );
}
